import * as React from 'react'

import { AvailableModules } from 'generated/featureDefinitions'
import { EnpsTabsDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import { isModuleAvailabilityEnabled } from 'modules/core/lib/isModuleAvailabilityEnabled'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const AnalyticsPage = React.lazy(() => import('modules/enps/pages/AnalyticsPage'))
const AnswersPage = React.lazy(() => import('modules/enps/pages/AnswersPage'))
const ConfigurationPage = React.lazy(() => import('modules/enps/pages/settings/ConfigurationPage'))
const RootPage = React.lazy(() => import('modules/enps/pages/RootPage'))
const IndexPage = React.lazy(() => import('modules/enps/pages/IndexPage'))
const ResultsPage = React.lazy(() => import('modules/enps/pages/ResultsPage'))

const enpsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.engagement.enps.path,
      element: <RootPage />,
      handle: {
        meta: ({ watchQuery }) => {
          return watchQuery({
            query: EnpsTabsDocument,
            variables: {
              moduleAvailabilityIds: [AvailableModules.enps],
            },
          }).map(({ data }) => {
            const upsellFlowEnabled = data.upsell._policies.canRequestUpsell.can ?? false
            const moduleAvailabilities =
              data?.companies?.moduleAvailabilitiesConnection?.nodes ?? []
            const hasEnps =
              moduleAvailabilities &&
              isModuleAvailabilityEnabled(moduleAvailabilities, AvailableModules.enps)

            return {
              title: i18n.t('enps.index.title'),
              subNavigation: [
                {
                  href: navigation.engagement.enps.answers.fullPath(),
                  title: i18n.t('enps.form.tabs.answers'),
                  index: true,
                  isVisible: (data.enps._policies.manageEnps.can && hasEnps) || !upsellFlowEnabled,
                },
                {
                  href: navigation.engagement.enps.analytics.fullPath(),
                  title: i18n.t('enps.form.tabs.analytics'),
                  isVisible: (data.enps._policies.manageEnps.can && hasEnps) || !upsellFlowEnabled,
                },
                {
                  href: navigation.engagement.enps.results.fullPath(),
                  title: i18n.t('enps.form.tabs.results'),
                  isVisible: (data.enps._policies.manageEnps.can && hasEnps) || !upsellFlowEnabled,
                },
                {
                  href: navigation.engagement.enps.configuration.fullPath(),
                  title: i18n.t('enps.form.tabs.index'),
                  isVisible: (data.enps._policies.manageEnps.can && hasEnps) || !upsellFlowEnabled,
                },
              ],
            }
          })
        },
      },
      children: [
        {
          index: true,
          element: <IndexPage />,
        },
        {
          path: navigation.engagement.enps.configuration.path,
          element: <ConfigurationPage />,
        },
        {
          path: navigation.engagement.enps.answers.path,
          element: <AnswersPage />,
        },
        {
          path: navigation.engagement.enps.analytics.path,
          element: <AnalyticsPage />,
        },
        {
          path: navigation.engagement.enps.results.path,
          element: <ResultsPage />,
        },
      ],
    },
  ]
}

export default enpsRoutes
